export default __webpack_public_path__ + "static/media/p5-8.ee7e5f5a.png";